import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

/** Cadre des blocs de la fiche élevage : titre, icône, et action à droite du titre. */
export const DetailCard = ({
  title,
  icon,
  action,
  children,
}: {
  title: string;
  icon: IconProp;
  action?: React.ReactNode;
  children: React.ReactNode;
}) => (
  <section
    className="bg-white rounded-xl overflow-hidden"
    style={{ boxShadow: "0px 2px 6px #d4d4d4" }}
  >
    <div className="flex items-center gap-3 px-4 py-3 bg-grey-light">
      <FontAwesomeIcon icon={icon} className="text-secondary" />
      <h2 className="font-oxaniumMedium truncate">{title}</h2>
      {action && <div className="ml-auto shrink-0">{action}</div>}
    </div>
    <div className="px-4 py-4">{children}</div>
  </section>
);

/** Bouton crayon des blocs modifiables. */
export const EditButton = ({
  onClick,
  label = "",
}: {
  onClick: () => void;
  label?: string;
}) => {
  const { t } = useTranslation();
  const title = label || t("breeding-detail-edit");
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      aria-label={title}
      className="w-8 h-8 flex items-center justify-center rounded-lg text-grey-medium hover:text-secondary"
    >
      <FontAwesomeIcon icon="pen" />
    </button>
  );
};

/** Bouton corbeille des blocs supprimables. */
export const DeleteButton = ({
  label,
  onClick,
}: {
  label: string;
  onClick: () => void;
}) => (
  <button
    type="button"
    onClick={onClick}
    title={label}
    aria-label={label}
    className="w-8 h-8 flex items-center justify-center rounded-lg text-grey-medium hover:text-red-600"
  >
    <FontAwesomeIcon icon="trash-can" />
  </button>
);

/** Ligne libellé / valeur en lecture. */
export const InfoRow = ({ label, value }: { label: string; value: string }) => (
  <div className="flex gap-4 py-1 text-sm">
    <dt className="w-1/3 shrink-0 text-grey-medium font-oxaniumMedium">
      {label}
    </dt>
    <dd className="min-w-0 break-words">{value || "-"}</dd>
  </div>
);
